import { render, staticRenderFns } from "./RideitPage.vue?vue&type=template&id=87861c76&scoped=true"
import script from "./RideitPage.vue?vue&type=script&lang=ts"
export * from "./RideitPage.vue?vue&type=script&lang=ts"
import style0 from "./RideitPage.vue?vue&type=style&index=0&id=87861c76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87861c76",
  null
  
)

export default component.exports